import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AdminDashboardSectionState, AdminDashboardTopServices } from "@/types/dashboard";

export type DashboardTopServicesState = AdminDashboardSectionState<AdminDashboardTopServices>;

export const dashboardTopServicesInitialState: DashboardTopServicesState = {
  data: null,
  error: null,
};

const slice = createSlice({
  name: "dashboardTopServices",
  initialState: dashboardTopServicesInitialState,
  reducers: {
    setDashboardTopServicesAction(state, { payload }: PayloadAction<AdminDashboardTopServices | null>) {
      state.data = payload;
      state.error = null;
    },
    setDashboardTopServicesErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload;
    },
  },
});

export const { setDashboardTopServicesAction, setDashboardTopServicesErrorAction } = slice.actions;
export default slice.reducer;
